import {Component, inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import {MatCheckbox} from "@angular/material/checkbox";
import {FormsModule} from "@angular/forms";

export interface ConfirmationModalData {
  title: string;
  content: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  confirmAction?: () => void;
  dontShowAgain?: boolean;
}

@Component({
  selector: 'app-confirmation-modal',
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    TranslateModule,
    MatCheckbox,
    FormsModule
  ],
    templateUrl: './confirmation-modal.component.html',
    styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  // Injections
  public readonly data: ConfirmationModalData = inject(MAT_DIALOG_DATA);
  public readonly dialogRef: MatDialogRef<ConfirmationModalComponent> = inject(MatDialogRef);

  hideDialogPersistent: boolean = false;

  confirm() {
    if (this.data.confirmAction) {
      this.data.confirmAction();
    }

    this.dialogRef.close(true);
  }

  get dontShowAgain() {
    return this.hideDialogPersistent;
  }

  set dontShowAgain(value: boolean) {
    this.hideDialogPersistent = value;

    if (!value) {
      if (localStorage.getItem('primus.hidePaginationWarning')) {
        localStorage.removeItem('primus.hidePaginationWarning');
      }
    }
    else {
      localStorage.setItem('primus.hidePaginationWarning', 'true');
    }
  }
}
